import { render, staticRenderFns } from "./Counter.component.vue?vue&type=template&id=bd33d172&scoped=true&lang=pug"
import script from "./Counter.component.vue?vue&type=script&lang=ts"
export * from "./Counter.component.vue?vue&type=script&lang=ts"
import style0 from "./Counter.component.vue?vue&type=style&index=0&id=bd33d172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd33d172",
  null
  
)

export default component.exports